export default "__VITE_ASSET__HANTYd$z__"